/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  PostPmpfUtentiImportaBody,
  SQLTransferResponse,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Importa gli utenti da PMPF
 * @summary Importa gli utenti da PMPF
 */
export const postPmpfUtentiImporta = (
  postPmpfUtentiImportaBody: PostPmpfUtentiImportaBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append('file', postPmpfUtentiImportaBody.file);

  return apiClientRequest<SQLTransferResponse>(
    {
      url: `/framework-cfg-utenti/pmpf/utenti/importa`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPostPmpfUtentiImportaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPmpfUtentiImporta>>,
    TError,
    { data: PostPmpfUtentiImportaBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPmpfUtentiImporta>>,
  TError,
  { data: PostPmpfUtentiImportaBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPmpfUtentiImporta>>,
    { data: PostPmpfUtentiImportaBody }
  > = props => {
    const { data } = props ?? {};

    return postPmpfUtentiImporta(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPmpfUtentiImportaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPmpfUtentiImporta>>
>;
export type PostPmpfUtentiImportaMutationBody = PostPmpfUtentiImportaBody;
export type PostPmpfUtentiImportaMutationError = ErrorType<unknown>;

/**
 * @summary Importa gli utenti da PMPF
 */
export const usePostPmpfUtentiImporta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPmpfUtentiImporta>>,
    TError,
    { data: PostPmpfUtentiImportaBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostPmpfUtentiImportaMutationOptions(options);

  return useMutation(mutationOptions);
};
